import React, { useEffect } from 'react'
import { Container, Grid2, Typography, Toolbar } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ModernNavbar from './ModernNavbar'
import Footer from './Footer'
import { getCompanyData } from '../../features/setup/useableSlice'

function DashbaordBlock2(props) {
    const navigate = useNavigate()
    const heading = props.heading
    const headingColor = props.headingColor
    const navLink = props.navLink
    return (
        <>
            <Grid2 container spacing={0.5}
                sx={{
                    background: '#1E90FF',
                    padding: 1, margin: 1, borderRadius: 2, boxShadow: 'black 2px 2px 5px', cursor: 'pointer'
                }}
                onClick={() => { navigate(navLink) }}
            >
                <Grid2 size={12}>
                    <Typography sx={{ textAlign: 'center', color: `${headingColor}`, fontSize: 30, fontWeight: 'bolder', textShadow: 'grey 2px 2px 2px' }}>{heading}</Typography>
                </Grid2>
                <Grid2 size={6} >
                    <Typography sx={{
                        backgroundColor: '#FFD700', color: '#000', padding: '2px 6px', borderRadius: '12px',
                        fontWeight: 'bolder', fontSize: '14px', textAlign: 'center',

                    }}>New</Typography>
                </Grid2>
                <Grid2 size={6} >
                    <Typography sx={{
                        backgroundColor: '#FFD700', color: '#000', padding: '2px 6px', borderRadius: '12px',
                        fontWeight: 'bolder', fontSize: '14px', textAlign: 'center',
                    }}>Total</Typography>
                </Grid2>
                <Grid2 size={6}>
                    <Typography sx={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                        textShadow: '1px 1px 1px #000', textAlign: 'center'
                    }}>1</Typography>
                </Grid2>
                <Grid2 size={6}>
                    <Typography sx={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                        textShadow: '1px 1px 1px #000', textAlign: 'center'
                    }}>5</Typography>
                </Grid2>
            </Grid2 >

        </>
    )
}

export default function Dashbaord() {
    // const theme = useTheme()
    // const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { user } = useSelector(state => state.auth)

    useEffect(() => {
        if (!user) {
            navigate('/Login')
        } else {
            dispatch(getCompanyData())
        }
    }, [user, navigate, dispatch])

    // useEffect(() => {
    //     // dispatch(getyws())
    // }, [dispatch])

    return (
        <>
            <ModernNavbar />
            <Toolbar />
            <Container >
                <Grid2 container spacing={2}>
                    <Grid2 size={12} sx={{ background: '#1E90FF', borderRadius: 4 }}>
                        <Typography style={{
                            textAlign: 'center', fontSize: 50, color: 'white', fontWeight: 'bolder',
                            textShadow: 'black 3px 3px 10px',
                        }}>
                            Dashbaord New
                        </Typography>
                    </Grid2>
                    <Grid2 size={4}>
                        <DashbaordBlock2 heading={'Departments'} headingColor={'#F0F0F0'} navLink={'/Departments'} />
                    </Grid2>
                    <Grid2 size={4}>
                        <DashbaordBlock2 heading={'Units'} headingColor={'#F0F0F0'} navLink={'/Units'} />
                    </Grid2>
                    <Grid2 size={4}>
                        <DashbaordBlock2 heading={'Shifts'} headingColor={'#F0F0F0'} navLink={'/Shifts'} />
                    </Grid2>
                    <Grid2 size={4}>
                        <DashbaordBlock2 heading={'Employees'} headingColor={'#F0F0F0'} navLink={'/EmployeeList'} />
                    </Grid2>
                    <Grid2 size={4}>
                        <DashbaordBlock2 heading={'Present'} headingColor={'#F0F0F0'} navLink={'/CurrDayAtt'} />
                    </Grid2>
                    <Grid2 size={4}>
                        <DashbaordBlock2 heading={'Salary Sheet'} headingColor={'#F0F0F0'} navLink={'/SalarySheet'} />
                    </Grid2>
                </Grid2>
            </Container >
            <Footer />
        </>
    )
}
